import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import util from "@/libs/util.js";
export default {
  name: 'DepositOperationDialog',
  props: {
    depositTypeMap: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    depositStatusMap: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      innerVisible: false,
      localForm: {},
      localDepositList: [],
      isHasPaymentType: false,
      localSaveLoading: false
    };
  },
  methods: {
    open: function open() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.localForm = _objectSpread({}, payload);
      this.innerVisible = true;
      this.fetchDepositList();
    },
    close: function close() {
      this.innerVisible = false;
    },
    fetchDepositList: function fetchDepositList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (_this.localForm.id) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _this.$api.getCompanyDepositListByCompanyId({
                companyId: _this.localForm.id
              });
            case 2:
              res = _context.v;
              res.data.forEach(function (item) {
                item.isSelected = 0;
                item.residue = item.amount;
                item.companyDepositOrderVos.forEach(function (order) {
                  if (order.operationType !== 'revocation') {
                    item.residue += order.amount;
                  }
                });
                item.residue = item.residue < 0 ? 0 : item.residue;
              });
              _this.localDepositList = res.data;
              _this.isHasPaymentType = false;
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 打开关联款项页面
    openPaymentRecord: function openPaymentRecord(transactionSerialNumber) {
      window.open("".concat(window.location.origin + window.location.pathname, "#/quarter/paymentRecord?receiptWaterNbr=").concat(transactionSerialNumber));
    },
    //预览 pdf 文件
    previewPdf: function previewPdf(url) {
      window.open(url);
    },
    selectOrder: function selectOrder(row) {
      var _this2 = this;
      if (row.residue <= 0) return;
      this.localDepositList.forEach(function (item) {
        if (item.id == row.id) {
          item.isSelected = 1;
          _this2.localForm.certificateUrl = item.certificateUrl;
          _this2.localForm.depositId = item.id;
          _this2.localForm.residue = item.residue;
          if (item.paymentType) {
            _this2.localForm.paymentType = item.paymentType;
          }
          _this2.isHasPaymentType = !!item.paymentType;
        } else {
          item.isSelected = 0;
        }
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var f, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!_this3.localSaveLoading) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              f = _this3.localForm;
              if (f.operationType) {
                _context2.n = 2;
                break;
              }
              _this3.$message.error('请选择操作类型');
              return _context2.a(2);
            case 2:
              if (f.amount) {
                _context2.n = 3;
                break;
              }
              _this3.$message.error('请输入金额');
              return _context2.a(2);
            case 3:
              if (!(f.operationType === 'refund' || f.operationType === 'newly')) {
                _context2.n = 4;
                break;
              }
              if (f.paymentType) {
                _context2.n = 4;
                break;
              }
              _this3.$message.error('请选择支付平台');
              return _context2.a(2);
            case 4:
              if (!(f.operationType === 'newly')) {
                _context2.n = 5;
                break;
              }
              if (f.certificateUrl) {
                _context2.n = 5;
                break;
              }
              _this3.$message.error('请上传押金支付凭证');
              return _context2.a(2);
            case 5:
              if (!(f.operationType === 'refund' || f.operationType === 'deduct')) {
                _context2.n = 7;
                break;
              }
              if (f.depositId) {
                _context2.n = 6;
                break;
              }
              _this3.$message.error('请选择押金记录');
              return _context2.a(2);
            case 6:
              if (!(f.amount > f.residue)) {
                _context2.n = 7;
                break;
              }
              _this3.$message.error('金额不能大于剩余金额');
              return _context2.a(2);
            case 7:
              _this3.localSaveLoading = true;
              _context2.n = 8;
              return _this3.$api.saveCompanyDepositOrder({
                id: f.depositId,
                companyId: f.id,
                operationType: f.operationType,
                certificateUrl: f.certificateUrl,
                operationDesc: f.operationDesc,
                adminId: util.cookies.get('uuid'),
                amount: f.operationType === 'newly' ? f.amount : f.amount * -1,
                status: _this3.depositStatusMap ? _this3.depositStatusMap[f.operationType] : undefined,
                paymentType: f.paymentType
              });
            case 8:
              res = _context2.v;
              _this3.localSaveLoading = false;
              if (res.code === 200) {
                _this3.$message.success('操作成功');
                _this3.$emit('updated');
                _this3.close();
              } else {
                _this3.$message.error(res.msg);
              }
            case 9:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};